export function parseComparisonIds(rawIds = "") {
  const source = Array.isArray(rawIds) ? rawIds : String(rawIds ?? "");
  const normalized = (Array.isArray(source) ? source : source.split(/[,&]/))
    .map((value) => String(value).trim())
    .filter(Boolean);

  const seen = new Set();
  const uniqueIds = normalized.filter((id) => {
    if (seen.has(id)) return false;
    seen.add(id);
    return true;
  });

  // Enforce maximum of 4 tours
  return uniqueIds.slice(0, 4);
}

export function buildComparisonQueryPath(ids) {
  const normalized = parseComparisonIds(ids);
  if (!normalized.length) return "/comparison";
  return `/comparison?ids=${normalized.join(",")}`;
}

export function buildComparisonDetailPath(ids) {
  // Alias to new path for backward compatibility during transition
  return buildComparisonQueryPath(ids);
}

export function buildSelectionQueryParam(ids) {
  const normalized = parseComparisonIds(ids);
  if (!normalized.length) return "";
  return `compare=${normalized.join(",")}`;
}
